<template>
  <div>
    <div v-for="(point, i) in filteredHistory" :key="i">
      <b-card>
        <b-row align-v="center">
          <b-col>
            <b-badge variant="light" class="mr-1 px-2">
              {{ point.event_type.toUpperCase() }}
            </b-badge>
          </b-col>
          <b-col cols="auto">
            <small class="font-weight-bold text-dark">{{ formatDate(point.created_at) }}</small>
          </b-col>
        </b-row>

        <div v-if="point.event_type === 'redeemed' && point.to !== null">
          <hr />
          Giftcard was redeemed on {{ formatDate(point.giftcard.redeemed_at) }} and
          {{
            point.giftcard.experienced_at
              ? `experienced on ${formatDate(point.giftcard.experienced_at)}.`
              : 'is yet to be experienced.'
          }}
        </div>

        <div v-if="point.event_type === 'redeemed' && point.to === null">
          <hr />
          Giftcard was reverted on {{ formatDate(point.created_at) }}
        </div>

        <div v-if="point.event_type === 'invoiced'">
          <hr />
          Invoiced <a :href="point.invoiced.pdf" download>#{{ point.invoiced.id }}</a> on
          {{ formatDate(point.invoiced.created_at) }}
        </div>

        <div v-if="point.event_type === 'combined'">
          <hr />
          Giftcard was combined into giftcard with code
          <strong>{{ point.to }}</strong>
        </div>

        <div v-if="point.event_type === 'exchanged'">
          <hr />
          Exchanged for giftcard with code <strong>{{ point.exchanged.code }}</strong>
          <span v-if="giftcard.combined_to"
            ><br />Exchanged giftcard was combined into giftcard with code
            <strong>{{ giftcard.combined_to }}</strong></span
          >
        </div>

        <div v-if="point.event_type === 'csv_booked'">
          <hr />
          Exchanged for CSV with code <strong>{{ point.to }}</strong>
        </div>
      </b-card>
      <hr v-if="i !== filteredHistory.length - 1" />
    </div>
  </div>
</template>

<script>
import { giftcard } from '@youwish1/api-package'
import { formatDate } from '../page-helpers'

export default {
  name: 'GiftcardHistory',
  props: { giftcard },
  data() {
    return { history: [] }
  },
  computed: {
    filteredHistory() {
      return this.history.filter(history => this.shouldDisplayEvent(history.event_type))
    },
  },
  mounted() {
    this.loadContent()
  },
  methods: {
    formatDate,
    async loadContent() {
      const response = await giftcard.transactions(this.giftcard.id)
      this.history = response.data()
    },
    shouldDisplayEvent(event) {
      return !['activated', 'disabled', 'sum', 'full_sum', 'customized'].includes(event)
    },
  },
}
</script>
